'use client';

import React, { useEffect, useState, useRef } from 'react';
import styles from './scss/segmentation.module.scss';
import { getLycaChurnPredictionOverallRlt } from '../../apiservice/aiLycaPilot';
import BootstrapTable from 'react-bootstrap-table-next';

// Typing effect component
const TypingText = ({
  text,
  onDone,
  speed = 50,
}: {
  text: string;
  onDone?: () => void;
  speed?: number;
}) => {
  const [displayedText, setDisplayedText] = useState('');

  useEffect(() => {
    let i = 0;
    setDisplayedText('');
    const interval = setInterval(() => {
      setDisplayedText(text.slice(0, i + 1));
      i++;
      if (i === text.length) {
        clearInterval(interval);
        onDone?.();
      }
    }, speed);

    return () => clearInterval(interval);
  }, [text, speed, onDone]);

  return <>{displayedText}</>;
};

// Main Component
const Churn1 = ({ onComplete }: { onComplete?: () => void }) => {
  const [churnResult, setChurnResult] = useState<any>([]);
  const [visibleSection, setVisibleSection] = useState(0);
  const [phase, setPhase] = useState<'title' | 'desc' | 'chart' | 'done'>('title');
  const chartRefs = useRef<(HTMLDivElement | null)[]>([]);

  // Fetch API data on mount
  useEffect(() => {
    const getLycaChurnPredictionOverallRltData = async () => {
      try {
        const body = { fromYear: '2024', toYear: '2025', domainId: ' ' };
        const res = await getLycaChurnPredictionOverallRlt(body);

        if (res?.data?.statusCode === 200) {
          const data = res.data.response;
          console.log('getChurnPredictionOverallRlt----', data);
          setChurnResult(data);
        }
      } catch (error) {
        console.error('Error fetching segmentation target data:', error);
      }
    };

    getLycaChurnPredictionOverallRltData();
  }, []);

  console.log('churnResult--', churnResult[2]?.customerCount);

  // Sections mapped from churnResult (fallbacks added)
  const sections = [
    {
      title: churnResult[1]?.customerCount ?? 0,
      desc: 'Most likely to churn',
      chart: churnResult[1]?.segement ?? 'High risk—act now.',
      color: 'linear-gradient(180deg, #FFF 50%, #F5FFFC 100%)',
    },
    {
      title: churnResult[0]?.customerCount ?? 0,
      desc: 'Fairly likely to churn',
      chart: churnResult[0]?.segement ?? 'Moderate risk—engage proactively.',
      color: 'linear-gradient(180deg, #FFF 50%, #F5F5FF 100%)',
    },
    {
      title: churnResult[2]?.customerCount ?? 0,
      desc: 'Less likely to churn',
      chart: churnResult[2]?.segement ?? 'Low risk—keep nurturing.',
      color: 'linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)',
    },
    // {
    //   title: churnResult[2]?.customerCount ?? 0,
    //   desc: 'Complaints',
    //   chart: churnResult[2]?.segement ?? 'Microcopy for Current Complaints',
    //   color: 'linear-gradient(180deg, #FFF 50%, #FFFFF5 100%)',
    // },
  ];

  // Auto-scroll when section changes
  useEffect(() => {
    chartRefs.current[visibleSection]?.scrollIntoView({
      behavior: 'smooth',
      block: 'center',
    });
  }, [visibleSection]);

  // Reset typing phase when visible section changes
  useEffect(() => {
    setPhase('title');
  }, [visibleSection]);

  // Handle typing sequence
  const onTypingDone = () => {
    if (phase === 'title') {
      setPhase('desc');
    } else if (phase === 'desc') {
      setPhase('chart');
    } else if (phase === 'chart') {
      setPhase('done');
      setTimeout(() => {
        if (visibleSection < sections.length - 1) {
          setVisibleSection((prev) => prev + 1);
        } else {
          onComplete?.(); // ✅ trigger after last section done
        }
      }, 300);
    }
  };

  const data = [
  { id: 1, segment: 'Overall Likely to churn', customer_count: '38,419', revenue: '£768,380', Arpu: '£20' },
];

const columns = [
  { dataField: "segment", text: "Segment", sort: true },
  { dataField: "customer_count", text: "Customer Count", sort: true },
  { dataField: "revenue", text: "Revenue", sort: true },
  { dataField: "Arpu", text: "ARPU", sort: true },
];

  return (
    <div className={`${styles.allotmentsecsegt} ${styles.chunses}`}>
      {sections.map((section, i) => {
        if (i > visibleSection) return null;

        const isCurrent = i === visibleSection;
        return (
          <div
            key={i}
            className={styles.altblocksegt}
            style={{ background: section.color }}
            ref={(el) => (chartRefs.current[i] = el)}
          >
            {/* Title */}
            <p className={styles.altcount}>
              {isCurrent ? (
                phase === 'title' ? (
                  <TypingText text={String(section.title)} onDone={onTypingDone} />
                ) : (
                  section.title
                )
              ) : (
                section.title
              )}
            </p>

            {/* Description + Chart */}
            <div className={styles.altinfos}>
              <h4>
                {isCurrent ? (
                  phase === 'desc' ? (
                    <TypingText text={section.desc} onDone={onTypingDone} />
                  ) : phase === 'title' ? (
                    ''
                  ) : (
                    section.desc
                  )
                ) : (
                  section.desc
                )}
              </h4>
              <p>
                {isCurrent ? (
                  phase === 'chart' ? (
                    <TypingText text={section.chart} onDone={onTypingDone} />
                  ) : phase === 'done' ? (
                    section.chart
                  ) : (
                    ''
                  )
                ) : (
                  section.chart
                )}
              </p>
            </div>
          </div>
        );
      })}
           {/* Table */}
      {/* <div className='desktoptable'>
        <BootstrapTable keyField="id" data={data} columns={columns} />
      </div> */}
    </div>
  );
};

export default Churn1;
